import React from 'react';
import PropTypes from 'prop-types';
import './Education.scss';

const rootClass = 'education';
const contentClass= `${rootClass}__content`;
const contentList = `${contentClass}__list`;



const Education = ({ education }) => {
	const educationList = education.map((edu, idx) => {
		const { college, course, place, university, duration: { from, to } } = edu;
		return (
			<div className={contentList}>
				<div className={`${contentList}__college`}>{college},
					{place && <span className={`${contentList}__college__place`}>{place}</span>}
				</div>
				<div className={`${contentList}__course`}>{university} </div>
				<div className={`${contentList}__course`}>{course} </div>
				<div className={`${contentList}__year`}>{from}-{to}</div>
			</div>
		)
	});
	return (
		<div className={rootClass}>
			<h3 className={`${rootClass}__title`}>Education</h3>
			<div className={contentClass}>
				{educationList}
			</div>
			<div class="LI-profile-badge"  data-version="v1" data-size="medium" data-locale="en_US" data-type="horizontal" data-theme="light" data-vanity="harendrabisht"><a class="LI-simple-link" href='https://in.linkedin.com/in/harendrabisht?trk=profile-badge'>Harendra Singh Bisht</a></div>
		</div>
	);
};

Education.propTypes = {
	education: PropTypes.array,
};

export default Education;